import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { useSelector } from "react-redux";
import { isEmptyObject, useOuterClick } from "../../helpers";
import Select from "react-select";
const ResourceFilter = (props) => {
  const [celebrationFilter, SetCelebrationFilter] = useState([]);
  const [rStatus, SetRStatus] = useState([]);
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (!isEmptyObject(props?.filterData)) {
      if (props?.filterData?.status) {
        SetRStatus(props?.filterData?.status);
        let inputs = document.querySelectorAll('input[name="statusCheckbox"]');
        for (let i = 0; i < inputs.length; i++) {
          if (props?.filterData?.status.includes(inputs[i].value)) {
            inputs[i].checked = true;
          }
        }
      }
      if (props?.filterData?.celebration) {
        SetCelebrationFilter(props?.filterData?.celebration);
        let inputs = document.querySelectorAll(
          'input[name="celebrationCheckbox"]'
        );
        for (let i = 0; i < inputs.length; i++) {
          if (props?.filterData?.celebration.includes(inputs[i].value)) {
            inputs[i].checked = true;
          }
        }
      }

    } else {
      uncheckAll();
    }
  }, [props?.filterData]);

  const handleFilter = () => {
    let res = {};
    if (celebrationFilter.length > 0) {
      res.celebration = celebrationFilter;
    }
    if (rStatus.length > 0) {
      res.status = rStatus;
    }
    props.hangleFilterOption(res);
    props.setChannelPopover(false);
  };

  const StatusActivate = () => {
    let element = document.getElementById("activeBox");

    let event = new Event("change");
    if (element && event) {
      document.getElementById("activeBox").checked = true;
      element.dispatchEvent(event);
      statusChange(event);
    }
  };

  const celebrationChange = (e) => {
    let arr = celebrationFilter;
    if (
      e.target.value &&
      !celebrationFilter.includes(e.target.value) &&
      e.target.checked
    ) {
      arr.push(e.target.value);
    } else {
      if (arr.length > 0) {
        const index = arr.indexOf(e.target.value);
        if (index > -1) {
          arr.splice(index, 1);
        }
      }
    }
    SetCelebrationFilter(arr);
  };
  const statusChange = (e) => {
    let arr = rStatus;
    if (
      e.target.value &&
      !rStatus.includes(e.target.value) &&
      e.target.checked
    ) {
      arr.push(e.target.value);
    } else {
      if (arr.length > 0) {
        const index = arr.indexOf(e.target.value);
        if (index > -1) {
          arr.splice(index, 1);
        }
      }
    }
    SetRStatus(arr);
  };

  function uncheckAll() {
    document
      .querySelectorAll('input[type="checkbox"]')
      .forEach((el) => (el.checked = false));
  }

  const resetFilter = () => {
    SetCelebrationFilter([]);
    SetRStatus([]);
    uncheckAll();
    props.setChannelPopover(false);

    props.hangleFilterOption({});
  };

  const innerRef = useOuterClick((e) => {
    if (
      e.target.id !== "filter-button" &&
      e.target?.classList[0] !== "react-select__option" &&
      e.target?.tagName !== "svg"
    ) {
      props.setChannelPopover(false);
    }
  });

  return (
    <>
      <div ref={innerRef}>
        <Accordion allowMultipleExpanded allowZeroExpanded>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton className="accordion__button acrd-btn">
                Celebrations
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
            <ul className="check-list">
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="birthday"
                    id={`birthdayCheckbox`}
                    name="celebrationCheckbox"
                    onChange={(e) => celebrationChange(e)}
                  />
                   Birthday
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="workAnniversary"
                    id={`workAnniversary`}
                    name="celebrationCheckbox"
                    onChange={(e) => celebrationChange(e)}
                  />
                   Work Anniversary
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Status</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="check-list">
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="1"
                    name="statusCheckbox"
                    id="activeBox"
                    onChange={(e) => statusChange(e)}
                  />
                  Active
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="0"
                    name="statusCheckbox"
                    onChange={(e) => statusChange(e)}
                  />
                  Inactive
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
        <div className="button-group">
          <button
            className="proceedBtn"
            onClick={() => {
              handleFilter();
            }}
          >
            Apply
          </button>
          <button
            className="resetBtn"
            onClick={() => {
              resetFilter();
            }}
          >
            Reset
          </button>
        </div>
      </div>
    </>
  );
};

export default ResourceFilter;
